import React, { useState, useEffect } from "react";
import { Container } from "reactstrap";
import Axios from "axios";
import AOS from "aos";
import "aos/dist/aos.css";
import ExamplesNavbar from "../../components/Navbars/ExamplesNavbar";
import MilestonePageHeader from "../../components/Headers/MilestonePageHeader";
import DefaultFooter from "../../components/Footers/DefaultFooter";

function MilestonePage() {
    const [cover, setCover] = useState("");

    useEffect(() => {
        AOS.init(); // Initialize AOS

        document.body.classList.add("profile-page", "sidebar-collapse");
        document.documentElement.classList.remove("nav-open");
        window.scrollTo(0, 0);

        const getDataInfo = async () => {
            try {
                const response = await Axios.get(`${process.env.REACT_APP_API_URL}/jejak/readJejak`);
                if (response.data.length > 0) {
                    const data = response.data[0];
                    setCover(data.foto);
                }
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        };

        getDataInfo();

        return function cleanup() {
            document.body.classList.remove("profile-page", "sidebar-collapse");
        };
    }, []);

    return (
        <>
            <ExamplesNavbar />
            <div className="wrapper">
                <MilestonePageHeader />
                <Container
                    fluid
                    className="d-flex justify-content-center align-items-center"
                    style={{
                        minHeight: "calc(100vh - 150px)",
                        padding: 0,
                        margin: 0,
                    }}
                >
                    {cover ? (
                        <img
                            src={cover}
                            alt="Cover"
                            className="img-fluid"
                            style={{
                                maxHeight: "100%",
                                objectFit: "cover",
                            }}
                            data-aos="fade-left" // AOS attribute
                        />
                    ) : (
                        <p>Gambar tidak tersedia.</p>
                    )}
                </Container>
                <DefaultFooter />
            </div>
        </>
    );
}

export default MilestonePage;
